import { useFetchInvoicesSummary } from './useFetchInvoicesSummary'
import { useInvoicesListFilters } from './useInvoicesListFilters'

export const useInvoiceSummaryFiltered = () => {
  const [{ contactId, period, sendingState, searchQuery, status }] = useInvoicesListFilters()

  return useFetchInvoicesSummary({ contactId, period, sendingState, searchQuery, status })
}
